import { useEffect } from "react";

const AppMixer = ({ flowUuid }) => {
  const initializeAppMixer = async () => {
    if (!flowUuid) {
      throw new Error("No flow UUID provided for workflow initialization");
    }

    try {
      const appMixerInstance = new window.Appmixer({
        baseUrl: "https://api.ecs-prod.annmixer-dev.annaims.com",
      });
      
      const authentication = await appMixerInstance.api.authenticateUser(
        "alejandro@dealerlakes.com",
        "DkhXDMgERkqMFsP"
      );
      appMixerInstance.set("accessToken", authentication.token);

      const flowDesigner = appMixerInstance.ui.Designer({
        el: "#designer-container",
        options: {
          showButtonHome: false,
          menu: [{ event: "flow:rename", label: "Rename" }],
          toolbar: [
            ["undo", "redo"],
            ["zoom-to-fit", "zoom-in", "zoom-out"],
            ["logs"],
          ],
        },
      });

      flowDesigner.set("flowId", flowUuid);
      flowDesigner.open();
    } catch (error) {
      throw new Error(`Failed to initialize AppMixer workflow: ${error.message}`);
    }
  };

  useEffect(() => {
    if (flowUuid) {
      initializeAppMixer().catch(error => {
        console.error("AppMixer initialization failed:", error.message);
      });
    }
  }, [flowUuid]);

  if (!flowUuid) {
    return (
      <div style={{ display: "flex", height: "calc(100vh - 240px)", alignItems: "center", justifyContent: "center" }}>
        <div style={{ textAlign: "center" }}>
          <p>Workflow will be available after the trigger is published.</p>
          <p style={{ fontSize: "14px", color: "#666" }}>
            Create and publish your trigger first, then return to this tab to build your workflow.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", height: "calc(100vh - 240px)" }}>
      <div></div>
      <div style={{ flex: 1, position: "relative" }}>
        <div id="flow-manager-container"></div>
        <div id="designer-container"></div>
      </div>
    </div>
  );
};

export default AppMixer;
